export const LOGIC_OPERATOR = {
  AND: 'AND',
  OR: 'OR'
}

export const getReadableLogicOperator = logicOperator => {
  switch (logicOperator) {
    case LOGIC_OPERATOR.AND:
      return 'És'
    case LOGIC_OPERATOR.OR:
      return 'Vagy'
  }
}
